import React from 'react';
import { DefaultVipHeaderTitle } from '../styledComponents';
function DefaultVipHeader({ title }) {
  return <DefaultVipHeaderTitle>{title}</DefaultVipHeaderTitle>;
}

export default DefaultVipHeader;

